import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Modal } from '@material-ui/core';
import { API, Auth } from 'aws-amplify';
import React, { useEffect, useRef, useState } from 'react';
import { ModalBody, ModalFooter, ProgressBar, Spinner } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { fetchedPodcast } from '../redux/actions';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchPodcasts, getPodcastId } from '../utils/api';
import { sortArrayAtoZ } from '../utils/utils';
import { prosodyRateValues, voices } from '../utils/voices-data';
import { createXmlFile } from '../utils/xml-creator';
import Content from './Content';

type Props = {
  loading: boolean;
};

const UploadText = (props: Props): JSX.Element => {
  const history = useHistory();

  const documentId = useRef<HTMLInputElement>(null);
  const customerId = useRef<HTMLSelectElement>(null);
  const publicationYearId = useRef<HTMLInputElement>(null);
  const publisherLocationId = useRef<HTMLInputElement>(null);
  const authorId = useRef<HTMLInputElement>(null);
  const publisherId = useRef<HTMLInputElement>(null);
  const titleId = useRef<HTMLInputElement>(null);
  const textId = useRef<HTMLTextAreaElement>(null);
  const description = useRef<HTMLTextAreaElement>(null);
  const externalUrl = useRef<HTMLInputElement>(null);
  const uploadPdf = useRef<HTMLInputElement>(null);
  const uploadMp3 = useRef<HTMLInputElement>(null);
  const [reqvaluedocId, setReqvaluedocId] = useState(false);
  const [reqvaluecustId, setReqvaluecustId] = useState(false);
  const [reqvalueauthorsId, setReqvalueAuthorId] = useState(false);
  const [reqvalueLanguage, setReqvalueLanguage] = useState(false);
  const [reqvaluetitleId, setReqvalueTitleId] = useState(false);
  const [reqvaluefile, setReqvaluefile] = useState(false);
  const [reqvaluedesc, setReqvalueDesc] = useState(false);
  const [reqvalueMp3, setReqvalueMp3] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertVariant, setAlertVariant] = useState('success');
  const [message, setMessage] = useState('');
  const [validated, setValidated] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('en-US');
  const [selectedVoiceLanguage, setSelectedVoiceLanguage] = useState('default');
  const [selectedSettings, setSelectedSettings] = useState({});
  const { podcasts } = useAppSelector((state) => state.podcasts);
  const customersListJson = process.env.REACT_APP_CUSTOMER_IDS_URL;
  const [customerIds] = useState(process.env.REACT_APP_CUSTOMER_IDS?.split(', ')!);
  const [uploading, setUploading] = useState<boolean>(false);
  const [selectedPdfFile, setSelectedPdfFile] = useState<File | null>(null);
  const [selectedMp3, setSelectedMp3] = useState<File | null>(null);
  const [showMp3Input, setShowMp3Input] = useState(false);
  const [uploadingMp3, setUploadingMp3] = useState(false);
  const [responseSignedMp3Url, setResponseSignedMp3Url] = useState('');
  const [openMp3Modal, setOpenMp3Modal] = useState(false);
  const [docId, setDocId] = useState(null);
  const [year, setYear] = useState('');
  const [location, setLocation] = useState('');
  const [validYear, setValidYear] = useState(true);
  const [reqvaluepublisherId, setReqvaluepublisherId] = useState(false);
  const [author, setAuthor] = useState('');
  const [publisher, setPublisher] = useState('');
  const { podcast } = useAppSelector((state) => state.podcast);

  const dispatch = useAppDispatch();

  const voiceIdRef = useRef<HTMLSelectElement>(null);
  const enginesRef = useRef<HTMLSelectElement>(null);
  const domainsRef = useRef<HTMLSelectElement>(null);
  const speakingRateRef = useRef<HTMLSelectElement>(null);

  const defaultSettings = {
    prosodyRate: 110,
    languages: {
      'en-US': { voiceId: 'Matthew', engine: 'neural', domain: 'empty', engines: ['neural', 'standard'], domains: [] },
      'en-GB': { voiceId: 'Amy', engine: 'neural', domain: 'empty', engines: ['neural', 'standard'], domains: [] },
      'ja-JP': { voiceId: 'Takumi', engine: 'standard', domain: 'empty', engines: ['neural', 'standard'], domains: [] },
      'zh-CN': { voiceId: 'Zhiyu', engine: 'neural', domain: 'empty', engines: ['neural', 'standard'], domains: [] },
      'es-ES': { voiceId: 'Lucia', engine: 'neural', domain: 'empty', engines: ['neural', 'standard'], domains: [] },
      'es-MX': { voiceId: 'Mia', engine: 'neural', domain: 'empty', engines: ['neural', 'standard'], domains: [] },
      'es-US': { voiceId: 'Lupe', engine: 'neural', domain: 'news', engines: ['neural', 'standard'], domains: ['news'] },
    },
  };

  useEffect(() => {
    if (selectedVoiceLanguage !== 'default') {
      setSelectedSettings(voices[selectedVoiceLanguage][0]);
    }
  }, [selectedVoiceLanguage]);

  useEffect(() => {}, [selectedSettings]);

  useEffect(() => {
    if (customersListJson && customersListJson.startsWith('http')) {
      fetchPodcasts(dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAuthor('');
    setPublisher('');
    setYear('');
    setLocation('');
  }, []);

  const generateUID = async () => {
    const node = documentId.current;
    if (node) {
      node.value = uuidv4();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      setSelectedPdfFile(files[0]);
    }
  };

  const handleRemoveFile = () => {
    setSelectedPdfFile(null);
    if (uploadPdf.current) {
      uploadPdf.current.value = '';
    }
  };

  const handleMp3Change = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const selected = files[0];
      if (selected.name.endsWith('.mp3')) {
        // await new Promise(resolve => setTimeout(resolve, 2000)); // Replace with actual processing logic
        setSelectedMp3(selected);
      } else {
        // Handle error: Display a message to the user that only MP3 files are allowed
        console.error('Only MP3 files are allowed.');
      }
    }
  };

  const handleRemoveMp3 = () => {
    setSelectedMp3(null);
    if (uploadMp3.current) {
      uploadMp3.current.value = '';
    }
  };

  const uploadFileToS3 = async (signedUrl: string, file: File) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'multipart/form-data');
    const formData = new FormData();
    formData.append('mp3', file);

    try {
      const response = await fetch(signedUrl, {
        method: 'PUT',
        body: formData,
        headers: myHeaders,
        redirect: 'follow',
      });

      console.log('Upload successful:', response);
      // setSelectedMp3(null);
      setUploadingMp3(false);
      return 'SUCCESS';
    } catch (error) {
      console.error('Error uploading file:', error);
      setUploadingMp3(false);
      return 'ERROR';
    }
  };

  const handleCloseMp3Modal = () => {
    setOpenMp3Modal(false);
    setSelectedMp3(null);
  };

  const handleCustomerOnChange = async (e) => {
    getPodcastId(e.target.value)
      .then((podcast) => {
        fetchedPodcast(podcast);

        setAuthor(podcast?.author);
        setPublisher(podcast?.publisher);
        setYear(podcast?.publicationYear);
        setLocation(podcast?.publicationLocation);
        setSelectedLanguage(podcast?.language || '');
      })
      .catch((error) => {
        fetchedPodcast(null, 'Error retrieving data', true);
      });
  };

  const uploadFile = async (addImages) => {
    const publicationYearNode = publicationYearId.current;
    const publisherLocationNode = publisherLocationId.current;
    const authorNode = authorId.current;
    const publisherNode = publisherId.current;
    const titleNode = titleId.current;
    const documentNode = documentId.current;
    const customerNode = customerId.current;
    const textNode = textId.current;
    const descriptionNode = description.current;
    const externalUrlNode = externalUrl.current || undefined;
    const uploadPdfNode = uploadPdf.current;
    const regexpDocumentId = new RegExp(/^[a-zA-Z0-9_-]+$/gi);

    let pollyParams = {};

    if (selectedVoiceLanguage !== 'default') {
      const provider = selectedSettings['provider'];
      const domain = domainsRef.current?.value === 'empty' ? '' : domainsRef.current?.value;
      pollyParams = {
        engine: enginesRef.current?.value,
        languageCode: selectedLanguage,
        speekingRate: speakingRateRef.current?.value,
        provider: provider,
        sampleRate: 24000,
        voiceId: voiceIdRef.current?.value,
        domain: domain,
        pitch: 100,
      };
    }

    if (documentNode && customerNode && authorNode && textNode && titleNode && descriptionNode && publisherNode) {
      setShowAlert(false);
      if (documentNode.value === null || documentNode.value.trim() === '') {
        setReqvaluedocId(true);
        return;
      } else if (!regexpDocumentId.test(documentNode.value)) {
        setValidated(true);
        return;
      } else {
        setReqvaluedocId(false);
        setValidated(false);
      }

      if (customerNode.value === null || customerNode.value === '0') {
        setReqvaluecustId(true);
        return;
      } else {
        setReqvaluecustId(false);
      }

      if (validYear) {
        setValidYear(true);
      } else {
        setValidYear(false);
        return;
      }

      if (selectedLanguage === '') {
        setReqvalueLanguage(true);
        return;
      } else {
        setReqvalueLanguage(false);
      }

      if (!titleNode.value || titleNode.value.trim() === '') {
        setReqvalueTitleId(true);
        return;
      } else {
        setReqvalueTitleId(false);
      }

      if ((!textNode.value || textNode.value.trim() === '') && !showMp3Input) {
        setReqvaluefile(true);
        return;
      } else {
        setReqvaluefile(false);
      }

      if (!descriptionNode.value || descriptionNode.value.trim() === '') {
        setReqvalueDesc(true);
        return;
      } else {
        setReqvalueDesc(false);
      }

      if (showMp3Input) {
        if (!selectedMp3) {
          setReqvalueMp3(true);
          return;
        } else {
          setReqvalueMp3(false);
        }
      }

      const myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`);
      let formdata = new FormData();
      formdata.append('documentId', documentNode.value);
      formdata.append('customerId', customerNode.value);
      formdata.append(
        'xml',
        createXmlFile(
          selectedLanguage,
          titleNode.value,
          authorNode.value,
          textNode.value,
          descriptionNode?.value,
          externalUrlNode!.value,
          publicationYearNode?.value,
          publisherLocationNode?.value,
          publisherNode.value,
        ),
        'ms3.xml',
      );
      formdata.append('externalMp3FileExists', showMp3Input.toString());
      if (selectedPdfFile) {
        formdata.append('pdf', selectedPdfFile);
      }
      if (selectedVoiceLanguage !== 'default') {
        formdata.append('pollyParams', JSON.stringify(pollyParams));
      }

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      const apiName = 'Columbia';
      const path = '/document';

      setUploading(true);
      await API.post(apiName, path, requestOptions)
        .then((response) => {
          setDocId(response.documentId);
          documentNode.value = '';
          customerNode.value = '0';
          authorNode.value = '';
          titleNode.value = '';
          textNode.value = '';
          descriptionNode.value = '';
          externalUrlNode!.value = '';
          uploadPdfNode!.value = '';
          publicationYearNode!.value = '';
          publisherLocationNode!.value = '';
          publisherNode!.value = '';
          setYear('');
          setSelectedLanguage('en-US');

          setSelectedPdfFile(null);
          setShowMp3Input(false);
          setShowAlert(true);
          setAlertVariant('success');
          setMessage('Success');
          setUploading(false);
          if (response.signedUrl && selectedMp3) {
            setResponseSignedMp3Url(response.signedUrl);
            setOpenMp3Modal(true);
            setUploadingMp3(true);
            console.log('response.signedUrl', response.signedUrl);
            uploadFileToS3(response.signedUrl, selectedMp3);
          }
          if (addImages) history.push(`/document/${response.documentId}`);
        })
        .catch((error) => {
          console.log(error);
          setShowAlert(true);
          setAlertVariant('danger');
          setMessage('Error');
          setUploading(false);
        });
    }
  };

  const sortPodcastIdArray = () => {
    if (podcasts && podcasts.length > 0) {
      const editablePodcastIdArray = [...podcasts];
      sortArrayAtoZ(editablePodcastIdArray);
      return editablePodcastIdArray;
    }
    return undefined;
  };

  const handleYearChange = (event) => {
    const inputYear = event.target.value;
    const isValidYear = /^\d{4}$|^$/.test(inputYear);
    setYear(inputYear);
    setValidYear(isValidYear);
  };

  return (
    <Content loading={props.loading}>
      {showAlert ? (
        <Alert variant={alertVariant} dismissible onClose={() => setShowAlert(false)} style={{ zIndex: 999 }}>
          {message}
        </Alert>
      ) : (
        ''
      )}
      <Form>
        <Container className="mt-5">
          <Row className="justify-content-between align-items-center">
            <Col>
              <label htmlFor="documentId">Document ID</label>
              <InputGroup className="mb-3">
                <FormControl ref={documentId} />
                <InputGroup.Append>
                  <Button variant="info" onClick={generateUID}>
                    Generate UID
                  </Button>
                </InputGroup.Append>
                <Form.Control.Feedback
                  type="invalid"
                  style={{
                    display: `${reqvaluedocId || validated ? 'block' : 'none'}`,
                  }}
                >
                  Please insert a valid UID or press the button Generate a random one.
                </Form.Control.Feedback>
              </InputGroup>
              <Form.Group controlId="customerId">
                <Form.Label>Customer ID</Form.Label>
                <Form.Control as="select" ref={customerId} onChange={handleCustomerOnChange}>
                  <option value={0}></option>
                  {podcasts !== undefined &&
                    podcasts?.length > 0 &&
                    !process?.env?.REACT_APP_TABS?.includes('NONE') &&
                    sortPodcastIdArray()?.map(
                      (c: {
                        id: string | number | readonly string[] | undefined;
                        title: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
                      }) => (
                        <option key={c.id?.toString()} value={c.id}>
                          {c.id}
                        </option>
                      ),
                    )}
                  {process?.env?.REACT_APP_TABS?.includes('NONE') &&
                    customerIds.map((c) => (
                      <option key={c.toString()} value={c}>
                        {c}
                      </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback
                  type="invalid"
                  style={{
                    display: `${reqvaluecustId ? 'block' : 'none'}`,
                  }}
                >
                  Please select a Customer.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="languageId">
                <Form.Label>Language</Form.Label>
                <Form.Control
                  as="select"
                  onChange={(e) => {
                    setSelectedLanguage(e.target.value);
                    setSelectedVoiceLanguage('default');
                  }}
                  value={selectedLanguage}
                >
                  <option value={''}></option>
                  <option value={'en-GB'}>English GB</option>
                  <option value={'en-US'}>English US</option>
                  <option value={'ja-JP'}>Japanese</option>
                  <option value={'zh-CN'}>Chinese</option>
                  <option value={'es-ES'}>Spanish European</option>
                  <option value={'es-MX'}>Spanish Mexican</option>
                  <option value={'es-US'}>Spanish US</option>
                </Form.Control>
                <Form.Control.Feedback
                  type="invalid"
                  style={{
                    display: `${reqvalueLanguage ? 'block' : 'none'}`,
                  }}
                >
                  Please insert language.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="publisherId">
                <Form.Label>Publisher</Form.Label>
                <Form.Control as="input" ref={publisherId} defaultValue={publisher} />
              </Form.Group>
              <Form.Group controlId="publisherLocationId">
                <Form.Label>Publisher Location</Form.Label>
                <Form.Control as="input" ref={publisherLocationId} defaultValue={location} />
              </Form.Group>
              <Form.Group controlId="publicationYearId">
                <Form.Label>Publication Year</Form.Label>
                <Form.Control
                  ref={publicationYearId}
                  type="text" // Using text type to allow four-digit input
                  value={year}
                  onChange={handleYearChange}
                  isInvalid={!validYear}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{
                    display: `${validYear ? 'none' : 'block'}`,
                  }}
                >
                  Please insert a valid publication year.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="authorId">
                <Form.Label>Authors</Form.Label>
                <Form.Control as="input" ref={authorId} defaultValue={author} />
              </Form.Group>
              <Form.Group controlId="titleId">
                <Form.Label>Title</Form.Label>
                <Form.Control as="input" ref={titleId} />
                <Form.Control.Feedback
                  type="invalid"
                  style={{
                    display: `${reqvaluetitleId ? 'block' : 'none'}`,
                  }}
                >
                  Please insert title.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="textId">
                <Form.Label>Content</Form.Label>
                <Form.Control as="textarea" ref={textId} rows={10} />
              </Form.Group>
              <Form.Control.Feedback
                type="invalid"
                style={{
                  display: `${reqvaluefile ? 'block' : 'none'}`,
                }}
              >
                Please type the content of the file.
              </Form.Control.Feedback>
              <Form.Group controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control as="textarea" ref={description} rows={5} />
              </Form.Group>
              <Form.Control.Feedback
                type="invalid"
                style={{
                  display: `${reqvaluedesc ? 'block' : 'none'}`,
                }}
              >
                Please type a description.
              </Form.Control.Feedback>
              <Form.Group controlId="externalUrl">
                <Form.Label>External Url</Form.Label>
                <Form.Control as="input" ref={externalUrl} />
              </Form.Group>
              <Form.Group controlId="showMp3Input">
                <Form.Check
                  type="checkbox"
                  label="Upload mp3 file?"
                  checked={showMp3Input}
                  onChange={() => setShowMp3Input(!showMp3Input)}
                />
              </Form.Group>
              {showMp3Input && (
                <Form.Group controlId="uploadMp3">
                  <Form.Label>Upload mp3</Form.Label>
                  <InputGroup>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <FormControl type="file" ref={uploadMp3} onChange={handleMp3Change} accept=".mp3" />
                      {selectedMp3 ? (
                        <InputGroup.Append>
                          <span
                            onClick={handleRemoveMp3}
                            style={{ padding: '2px 8px', backgroundColor: '#fafafa', cursor: 'pointer' }}
                          >
                            <FontAwesomeIcon icon={faTimes} color="red" />
                          </span>
                        </InputGroup.Append>
                      ) : (
                        <></>
                      )}
                    </div>
                    {/* {uploadingMp3 && (<ProgressBar animated now={100} style={{width: "200px"}} />)} */}
                  </InputGroup>
                </Form.Group>
              )}
              <Form.Control.Feedback
                type="invalid"
                style={{
                  display: `${reqvalueMp3 ? 'block' : 'none'}`,
                }}
              >
                You select to upload mp3 but not file selected. Please select mp3 file to upload.
              </Form.Control.Feedback>
              <Form.Group controlId="uploadPdf">
                <Form.Label>Upload pdf</Form.Label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Form.Control
                    type="file"
                    ref={uploadPdf}
                    onChange={handleFileChange}
                    style={{ width: 'auto' }}
                    accept=".pdf"
                  />
                  {selectedPdfFile && (
                    <InputGroup.Append>
                      <span
                        onClick={handleRemoveFile}
                        style={{ padding: '2px 8px', backgroundColor: '#fafafa', cursor: 'pointer' }}
                      >
                        <FontAwesomeIcon icon={faTimes} color="red" />
                      </span>
                    </InputGroup.Append>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col className="col-12">
              <div>
                <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">
                  Choose voice language:
                </label>
              </div>
            </Col>

            <Col className="col-xl-8 col-md-12">
              <Form.Control
                className="w-50"
                as="select"
                onChange={(e) => {
                  setSelectedVoiceLanguage(e.target.value);
                }}
                value={selectedVoiceLanguage === 'default' ? 'default' : selectedVoiceLanguage}
              >
                <option value={'default'}>Default</option>
                <option value={selectedLanguage}>{selectedLanguage}</option>
              </Form.Control>
            </Col>
          </Row>

          {selectedVoiceLanguage !== 'default' && (
            <div>
              <Row className="mt-3">
                <Col className="">
                  <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">{`Voice ${selectedVoiceLanguage}:`}</label>
                </Col>
              </Row>
              <Row>
                <Col className="flex col-xl-8 col-md-12">
                  <div className="mr-2">
                    <Form.Control
                      as="select"
                      ref={voiceIdRef}
                      onChange={(e) => {
                        const voiceItem = voices[selectedVoiceLanguage];
                        const filteredItem = voiceItem.filter((item) => item.voiceId === e.target.value);
                        //console.log('filteredItem', filteredItem, typeof filteredItem);
                        setSelectedSettings(filteredItem[0]);
                      }}
                    >
                      {selectedVoiceLanguage !== 'default' &&
                        voices[selectedVoiceLanguage]?.map((item) => (
                          <option key={`${item.voiceId} - ${item.provider}`} value={item.voiceId}>
                            {item.provider}: {item.voiceId} - {item.gender}
                          </option>
                        ))}
                    </Form.Control>
                  </div>

                  {selectedSettings && (
                    <>
                      <div className="mr-2">
                        <Form.Control as="select" ref={enginesRef}>
                          {selectedSettings['engines']?.map((value) => (
                            <option key={value} value={value}>
                              {value}
                            </option>
                          ))}
                        </Form.Control>
                      </div>
                      <div style={{ display: 'block' }}>
                        <Form.Control
                          as="select"
                          ref={domainsRef}
                          defaultValue={selectedSettings['domains']?.length > 0 ? selectedSettings['domains'][0] : 'empty'}
                          defaultChecked={selectedSettings['domains']?.length > 0 ? selectedSettings['domains'][0] : 'empty'}
                          onLoad={() => {}}
                        >
                          {selectedSettings['domains']?.map((value) => (
                            <option key={value} value={value}>
                              {value}
                            </option>
                          ))}
                          {selectedSettings['domains']?.length === 0 && (
                            <option key={`domain-empty`} value="empty">
                              empty
                            </option>
                          )}
                        </Form.Control>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="col-xl-8 col-md-12">
                  <label className="block text-gray-800 font-bold md:text-right mb-1 md:mb-0 pr-4">prosodyRate:</label>
                </Col>
              </Row>
              <Row>
                <Col className="col-xl-8 col-md-12">
                  <Form.Control
                    as="select"
                    ref={speakingRateRef}
                    className="w-25"
                    defaultValue={defaultSettings.prosodyRate}
                  >
                    {prosodyRateValues.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                  </Form.Control>
                </Col>
              </Row>
            </div>
          )}

          <Row className="mt-3">
            <Col className="col-xl-2 col-md-2">
              <Button variant="primary" onClick={() => uploadFile(false)} disabled={uploading}>
                {uploading && (
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginRight: '4px' }}
                  />
                )}
                Upload
              </Button>
            </Col>
            <Col className="col-xl-4 col-md-4">
              <Button variant="primary" onClick={() => uploadFile(true)} disabled={uploading}>
                {uploading && (
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginRight: '4px' }}
                  />
                )}
                Upload & Add Images
              </Button>
            </Col>
          </Row>
        </Container>
      </Form>
      <Modal
        open={openMp3Modal}
        onClose={handleCloseMp3Modal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box className="modal-wrapper">
          <Box className="modal-header">
            <Box className="title">Upload Mp3 File</Box>
          </Box>
          <ModalBody>
            {uploadingMp3 && (
              <div>
                <p
                  style={{ marginBottom: '10px', fontSize: '18px' }}
                >{`Your mp3 file ${selectedMp3?.name} is uploading...`}</p>
                <ProgressBar animated now={100} style={{ width: '100%' }} />
              </div>
            )}
            {!uploadingMp3 && (
              <div>
                <p style={{ fontSize: '18px' }}>{`Upload ${selectedMp3?.name} finished!`}</p>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button disabled={uploadingMp3} variant="danger" onClick={handleCloseMp3Modal}>
              Close
            </Button>
          </ModalFooter>
        </Box>
      </Modal>
    </Content>
  );
};

export default UploadText;
